import { IconType } from "./icons.types";

const StoreIconV2 = ({ className, color = "#8280FF" }: IconType) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M16.6667 10V15C16.6667 16.8409 15.1743 18.3333 13.3333 18.3333H6.66666C4.82571 18.3333 3.33333 16.8409 3.33333 15V10"
        stroke={color}
        strokeWidth="1.2"
      />
      <path
        d="M13.974 1.66669H6.02605C4.51159 1.66669 3.14971 2.70398 2.58725 4.28589L1.9556 6.06241C1.76439 6.60018 1.63222 7.17564 1.77168 7.72908C2.10197 9.03982 3.17354 10 4.44445 10C5.97857 10 7.22223 8.60091 7.22223 6.87502C7.22223 8.60091 8.46588 10 10 10C11.5341 10 12.7778 8.60091 12.7778 6.87502C12.7778 8.60091 14.0214 10 15.5556 10C16.8265 10 17.898 9.03982 18.2283 7.72908C18.3678 7.17564 18.2356 6.60018 18.0444 6.06241L17.4128 4.28589C16.8503 2.70398 15.4884 1.66669 13.974 1.66669Z"
        stroke={color}
        strokeWidth="1.2"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 14.1667C9.46345 15.2836 10.5396 15.2719 12.5 14.1667"
        stroke={color}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default StoreIconV2;
